export enum RefreshType {
    FULL_ORG_REFRESH = 'FULL_ORG_REFRESH',
    METADATA_TYPE = 'METADATA_TYPE',
}
